// extracted by mini-css-extract-plugin
export default {"edit-handle-modal":"edit-handle-modal_edit-handle-modal__dGR-0","edit-handle-modal__input-section":"edit-handle-modal_edit-handle-modal__input-section__OsZOq"};